import React, {useState} from 'react';
import * as Yup from 'yup';
import {Formik} from "formik";
import {FormGroup, Input, Label, Button, Alert} from "reactstrap";
import {isUserAuthenticated} from "../services/auth";
import api from "../services/api";
import {Redirect, useHistory} from "react-router-dom";

const ForgetPassword = () => {
    const history = useHistory();
    const [alert, setAlert] = useState({message: "", type: ""});
    const [formSubmitted, setFormSubmitted] = useState(false);

    const initialValues = {
        email: "",
        verification_code: ""
    };

    const validationSchema = Yup.object().shape({
        email: Yup.string().required()
    });

    const onSubmit = (values, setSubmitting) => {
        setAlert({message: "", type: ""});

        api.forgetPassword(values.email, values.verification_code).then(() => {
            setAlert({
                message: values.verification_code ? 
                "Thank you for verifying, please follow the instruction sent to your email to reset your password." : 
                "Please follow the instructions sent to your email to verify your account.",
                type: "success"
            });
            // set form submiitet to true when verification code is sent
            if (values.verification_code) {
                setFormSubmitted(true);
            }
            setSubmitting(false);
        }).catch(() => {
            setAlert({
                message: "This email doesn't match any of our records.",
                type: "danger"
            });
            setSubmitting(false);
        });
    };

    if (isUserAuthenticated()) {
        return <Redirect to="/enrollment"/>
    }

    return (
        <React.Fragment>
            <h1 className="page-header elementor-heading-title elementor-size-large">Forgot your password?</h1>

            <div className="elementor-divider"><span className="elementor-divider-separator"/></div>

            <Alert isOpen={!!alert.message.length} color={alert.type}>
                {alert.message}
            </Alert>

            {!formSubmitted ? (
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(values, {setSubmitting}) => onSubmit(values, setSubmitting)}
            >
                {(
                    {values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting}
                ) => (
                    <form onSubmit={handleSubmit} className="mb-3">
                        <FormGroup>
                            <Label for="email">Email</Label>
                            <Input type="email" name="email" id="email"
                                   onChange={handleChange}
                                   onBlur={handleBlur}
                                   value={values.email}
                                   invalid={!!(errors.email && touched.email && errors.email)}
                            />
                        </FormGroup>
                        {!!alert.message.length && <FormGroup>
                            <Label for="verification_code">Verification Code</Label>
                            <Input type="text" name="verification_code" id="verification_code"
                                   onChange={handleChange}
                                   onBlur={handleBlur}
                                   value={values.verification_code}
                                   invalid={!!(errors.verification_code && touched.verification_code && errors.verification_code)}
                            />
                        </FormGroup>}

                        <Button type="submit" disabled={isSubmitting} className="elementor-button mb-3">
                            Submit
                        </Button>

                        <p>
                            Need help logging in?  Please call our Support Team at <a href="tel:(877) 247-8817">(877) 247-8817</a>
                        </p>
                    </form>
                )}
            </Formik>
            ) : ""}
        </React.Fragment>
    );
};

export default ForgetPassword;
